import gql from 'graphql-tag';

const GET_ALL = gql `
    query all($perPage: Int!,$page: Int){
        agenda(first: $perPage, page: $page){
            data{
                uuid,
                judul,
                lokasi,
                waktu_mulai,
                waktu_selesai,
                kategori_agenda{
                  id,
                  nama,
                  warna
                }
            }
            paginatorInfo {
                count
                total
                hasMorePages
                currentPage
                lastPage
            }
        }
    }
`;

const GET_ALL_FILTER = gql `
  query Agenda($perPage: Int!, $page: Int, $filter: AgendaFilterArgs,$orderBy: [AgendaFilterOrderByOrderByClause!]) {
    agenda: agendaFilter(first: $perPage, page: $page, filter: $filter, orderBy: $orderBy) {
      data {
        uuid
        judul
        lokasi
        waktu_mulai
        waktu_selesai
      }
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
        perPage
      }
    }
  }
`;

const GET_DETAIL = gql `
    query find($id: String!){
        agendaByUuid(uuid: $id){
            id
            uuid,
            judul,
            lokasi,
            deskripsi,
            waktu_mulai,
            waktu_selesai,
            peserta,
            pengguna_id
            kategori_agenda{
              id,
              nama,
              warna

            }
            surat{
              id,
              index
            }
            peserta_agenda{
                id
                pengguna_id
                pengguna{
                    nama,
                    jabatan{
                        nama
                    }
                }
            }
            dokumen {
                id
                uuid
                nama
                lokasi
                besar_dokumen
                jenis_dokumen
                file_url
                tipe
                attribute
            }
        }
    }
`;

const CREATE = gql `
    mutation($input: AgendaCreateInput!,){
        agendaCreate(input: $input){
            id,
            uuid,
            judul,
            lokasi,
            deskripsi,
            waktu_mulai,
            waktu_selesai,
            peserta
        }
    }
`;

const UPDATE = gql `
    mutation($id: ID!, $input:AgendaUpdateInput!){
        agendaUpdate(id: $id,input:$input){
            judul,
            lokasi,
            deskripsi,
            waktu_mulai,
            waktu_selesai,
            peserta,
        }
    }
`;

const DELETE_PESERTA = gql `
    mutation($pesertaAgendaId:[ID!]){
        multipleDeletePesertaAgenda(pesertaAgendaId : $pesertaAgendaId){
            id
        }
    }
`;

export {
  CREATE,
  GET_ALL,
  GET_DETAIL,
  UPDATE,
  DELETE_PESERTA,
  GET_ALL_FILTER
}
